








import BaseComponent from "@/asdcom/BaseComponent";
import { L, FormatAddressResult } from "@/asdcom/BaseComponent";
import { Prop, Component, Watch } from "vue-property-decorator";
import {
  ApplicationDto,
  EzAddress,
  AppCrimeInfoDto,
  AppFedReportingInfoDto,
  ClaimDataDto,
  IClaimDataDto,
  IEzAddress
} from "@/asdcom/apiproxy/apiproxy.dto";

import ClaimSummarySectionComponent, {
  IClaimSummarySectionItem,
  IClaimSummaryLabelValue,
  IClaimSummarySectionData
} from "@/components/vcponlineok/claim-summary/claim-summary-section.vue";
import util from "@/lib/util";
import { unzip, unzipSync } from "zlib";
import { unlink } from "fs";

interface ISummarySection {
  sectionTitle: string;
  sectionData: any;
}

@Component({
  components: {
    ClaimSummarySectionComponent
  }
})
export default class ClaimSummarySections extends BaseComponent {
  @Prop()
  viewModel: IClaimDataDto;

  @Prop({ type: Boolean, default: () => false })
  canEdit: boolean;

  summarySections: ISummarySection[] = [];

  @Watch("viewModel")
  private generateSectionsData() {
    abp.log.debug({ "generateSectionsData val": this.viewModel });

    this.summarySections.push(<ISummarySection>{
      sectionTitle: L("VictimInformation"),
      sectionData: this.victimSectionData
    });

    /// moved this section to Victim Info.
    // this.summarySections.push(<ISummarySection>{
    //   sectionTitle: L("VictimRace"),
    //   sectionData: this.raceSectionData
    // });

    this.summarySections.push(<ISummarySection>{
      sectionTitle: L("ClaimantInformation"),
      sectionData: this.claimantSectionData
    });

    // this.summarySections.push(<ISummarySection>{
    //   sectionTitle: L("ContactInfo"),
    //   sectionData: this.contactSectionData
    // });

    this.summarySections.push(<ISummarySection>{
      sectionTitle: L("CrimeInformation"),
      sectionData: this.crimeSectionData
    });

    // this.summarySections.push(<ISummarySection>{
    //   sectionTitle: L("ClaimedExpenses"),
    //   sectionData: this.expensesSectionData
    // });

    // this.summarySections.push(<ISummarySection>{
    //   sectionTitle: L("InsuranceInformation"),
    //   sectionData: this.insuranceSectionData
    // });

    // this.summarySections.push(<ISummarySection>{
    //   sectionTitle: L("CivilSuitInformation"),
    //   sectionData: this.civilSuitSectionData
    // });

    // this.summarySections.push(<ISummarySection>{
    //   sectionTitle: L("VictimDependent"),
    //   sectionData: this.dependentsSectionData
    // });

    // this.summarySections.push(<ISummarySection>{
    //   sectionTitle: L("SuspectInformation"),
    //   sectionData: this.suspectsSectionData
    // });

    // this.summarySections.push(<ISummarySection>{
    //   sectionTitle: L("HowDidYouHearInfo"),
    //   sectionData: this.howDidFindProgramSectionData
    // });
  }

  created() {
    //abp.log.debug({ "----- claim-summary-sections Viewmodel": this.viewModel });
    //this.generateSectionsData();
  }

  get appObj(): IClaimDataDto {
    return this.viewModel;
  }

  // get appId() {
  //   if (!this.appObj) {
  //     return null;
  //   }
  //   return this.appObj.applicationId;
  // }

  handleChange(val: any) {
    // console.log(val);
  }

  formatAddressSingleLineHtml(addr: IEzAddress): string | undefined {
    //abp.log.debug({"formatAddressSignleLineHTML isEmpyt?":this.isObjectEmpty(addr)});
    let ret: string | undefined = undefined;
    if (!this.isObjectEmpty(addr)) {
      let ln1 = undefined;
      let ln2 = undefined;
      const bfAddr = this.formatAddress(addr);
      if (!!bfAddr) {
        if (!!bfAddr.line1) {
          ln1 = `<span class="text-nowrap">${bfAddr.line1}</span>`;
        }
        if (!!bfAddr.line2) {
          ln2 = `<span class="text-nowrap">${bfAddr.line2}</span>`;
        }
        if (!!ln1 && !!ln2) {
          ret = `${ln1}, ${ln2}`;
        } else if (!!ln1) {
          ret = ln1;
        } else if (!!ln2) {
          ret = ln2;
        }
      }
    }
    ``;
    return ret;
  }

  getRelationshipToVictimItem(
    relationshipToVictim?: number | string,
    relationshipOther?: string,
    labelKey?: string
  ): IClaimSummaryLabelValue | undefined {
    let rel = undefined;
    if (relationshipToVictim !== undefined) {
      if (
        this.hasValue(relationshipOther)
        // relationshipToVictim === 0
        //util.abp.constant.relationshipToVictim.otherDescription
      ) {
        rel = relationshipOther;
      } else {
        rel = this.getConstName("relationshipToVictim", relationshipToVictim);
      }
    }
    if (!!rel) {
      return {
        label:
          labelKey === undefined
            ? this.L("RelationshipToTheVictim")
            : this.L(labelKey),
        value: rel
      } as IClaimSummaryLabelValue;
    } else {
      return undefined;
    }
  }

  getClaimantsRelationshipToVictimItem(
    relationshipToVictim?: number,
    relationshipOther?: string,
    labelKey?: string
  ): IClaimSummaryLabelValue | undefined {
    let rel = undefined;
    if (relationshipToVictim !== undefined) {
      if (
        relationshipToVictim ===
        util.abp.constant.claimantRelationshipToVictim.otherDescription
      ) {
        rel = relationshipOther;
      } else {
        rel = this.getConstName(
          "claimantRelationshipToVictim",
          relationshipToVictim
        );
      }
    }
    if (!!rel) {
      return {
        label:
          labelKey === undefined
            ? this.L("RelationshipToTheVictim")
            : this.L(labelKey),
        value: rel
      } as IClaimSummaryLabelValue;
    } else {
      return undefined;
    }
  }

  getSuspectRelationshipToVictimItem(
    relationshipToVictim?: number,
    relationshipOther?: string,
    labelKey?: string
  ): IClaimSummaryLabelValue | undefined {
    let rel = undefined;
    if (relationshipToVictim !== undefined) {
      if (
        relationshipToVictim ===
        util.abp.constant.suspectRelationshipToVictim.otherDescription
      ) {
        rel = relationshipOther;
      } else {
        rel = this.getConstName(
          "suspectRelationshipToVictim",
          relationshipToVictim
        );
      }
    }
    if (!!rel) {
      return {
        label:
          labelKey === undefined
            ? this.L("RelationshipToTheVictim")
            : this.L(labelKey),
        value: rel
      } as IClaimSummaryLabelValue;
    } else {
      return undefined;
    }
  }

  // get howDidFindProgramSectionData(): IClaimSummarySectionData | undefined {
  //   if (this.appObj == undefined || this.appObj.howYouFindInfo == undefined)
  //     return;

  //   let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };
  //   const ds = this.appObj.howYouFindInfo;

  //   const topCol: IClaimSummaryLabelValue[] = [];

  //   let selectedValues: string[] = [];
  //   for (let i = 0; i < Object.keys(ds).length; i++) {
  //     const val: any = Object.values(ds)[i];
  //     const key: string = Object.keys(ds)[i];
  //     if (typeof val === "boolean" && val === true && key !== "otherDesc") {
  //       if (key === "other") {
  //         selectedValues.push(<string>ds.otherDesc);
  //       } else {
  //         selectedValues.push(this.L(key));
  //       }
  //     }
  //   }
  //   if (selectedValues.length > 0) {
  //     topCol.push({
  //       //html: `<ul><li>${selectedValues.join("</li><li>")}</li></ul>`,
  //       valueList: selectedValues,
  //     });

  //     ret.itemList.push({
  //       oneColTop: topCol
  //     });
  //   }

  //   return ret;
  // }

  // get suspectsSectionData(): IClaimSummarySectionData | undefined {
  //   if (this.appObj == undefined || this.appObj.suspects == undefined) return;

  //   let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

  //   ret.topCenter.push({
  //     label: this.L("IsSuspectKnown"),
  //     value: `${this.boolToYesNo(this.appObj.isSuspectKnown)}`
  //   });

  //   for (const ds of this.appObj.suspects) {
  //     const header: string = `<span class="font-weight-bold">${this.getFullName(
  //       ds.prefix,
  //       ds.firstName,
  //       ds.middleName,
  //       ds.lastName,
  //       ds.suffix
  //     )}</span>`;

  //     const leftCol: IClaimSummaryLabelValue[] = [];
  //     leftCol.push({
  //       label: this.L("HasBeenArest?"),
  //       value: this.boolToYesNo(ds.hasBeenArrested)
  //     });

  //     const rightCol: IClaimSummaryLabelValue[] = [];
  //     rightCol.push({
  //       label: this.L("HasChargesBeenFilled?"),
  //       value: this.boolToYesNo(ds.hasChargesBeenFiled)
  //     });

  //     const rel = this.getSuspectRelationshipToVictimItem(
  //       ds.relationshipToVictim,
  //       ds.relationshipOther
  //     );
  //     if (!!rel) {
  //       rightCol.push(rel);
  //     }

  //     const bottomCol: IClaimSummaryLabelValue[] = [];
  //     if (!!ds.criminalCaseNumber) {
  //       bottomCol.push({
  //         label: this.L("IfCharges?"),
  //         value: ds.criminalCaseNumber
  //       });
  //     }

  //     ret.itemList.push({
  //       headerHtml: header,
  //       leftCol: leftCol,
  //       rightCol: rightCol,
  //       oneColBottom: bottomCol,
  //     });
  //   }

  //   return ret;
  // }

  // get dependentsSectionData(): IClaimSummarySectionData | undefined {
  //   if (this.appObj == undefined || this.appObj.dependents == undefined) return;

  //   let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

  //   ret.topCenter.push({
  //     label: this.L("DoYouHaveAnyDependents"),
  //     value: `${this.boolToYesNo(this.appObj.isThereAnyDependents)}`
  //   });

  //   for (const ds of this.appObj.dependents) {
  //     const header: string = `<span class="font-weight-bold">${this.getFullName(
  //       ds.prefix,
  //       ds.firstName,
  //       ds.middleName,
  //       ds.lastName,
  //       ds.suffix
  //     )}</span>`;

  //     const leftCol: IClaimSummaryLabelValue[] = [];
  //     // if (!!ds.dob) {
  //     //   leftCol.push({
  //     //     label: this.L("DateOfBirth"),
  //     //     value: this.formatDate(new Date(ds.dob.toString()))
  //     //   });
  //     // }

  //     const rel = this.getRelationshipToVictimItem(
  //       ds.relationshipToVictim,
  //       ds.relationshipOther
  //     );
  //     if (!!rel) {
  //       leftCol.push(rel);
  //     }

  //     const rightCol: IClaimSummaryLabelValue[] = [];

  //     // if (!!ds.ssn) {
  //     //   rightCol.push({
  //     //     label: this.L("SSNShort"),
  //     //     value: ds.ssn
  //     //   });
  //     // }

  //     const bottomCol: IClaimSummaryLabelValue[] = [];

  //     bottomCol.push({
  //       label: this.L("PersonListedAsATaxReturn"),
  //       value: this.boolToYesNo(ds.isDependantOnVictimsTaxReturn)
  //     });

  //     ret.itemList.push({
  //       headerHtml: header,
  //       leftCol: leftCol,
  //       rightCol: rightCol,
  //       oneColBottom: bottomCol
  //     });
  //   }

  //   return ret;
  // }

  // get employmentSectionData(): IClaimSummarySectionData | undefined {
  //   if (this.appObj == undefined || this.appObj.victimEmployments == undefined)
  //     return;

  //   let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

  //   const question1Label = true //this.$store.state.vcponlineok.isApplicantVictim
  //     ? "DidYouHaveAJob"
  //     : "DidTheVictimHaveAJob";
  //   ret.topCenter.push({
  //     label: this.L(question1Label),
  //     value: `${this.boolToYesNo(this.appObj.victimHasEmployers)}`
  //   });

  //   const question2Label = true //this.$store.state.vcponlineok.isApplicantVictim
  //     ? "WereYouUnableToWorkDueToCrime"
  //     : "WasTheVictimUnableToWorkDueToCrime";
  //   ret.topCenter.push({
  //     label: this.L(question2Label),
  //     value: `${this.boolToYesNo(this.appObj.victimUnableToWorkDueToCrime)}`
  //   });

  //   for (const ds of this.appObj.victimEmployments) {
  //     const header: string = `<span class="font-weight-bold">${ds.employerBusinessName}</span>`;

  //     const topCol: IClaimSummaryLabelValue[] = [];

  //     if (!!ds.occupation) {
  //       topCol.push({
  //         label: this.L("Occupation"),
  //         value: ds.occupation
  //       });
  //     }

  //     const dateLine = [];

  //     if (!!ds.missWorkFromDate) {
  //       const fromDate = `${this.formatDate(
  //         new Date(ds.missWorkFromDate.toString())
  //       )}`;
  //       dateLine.push(fromDate);
  //     }
  //     if (!!ds.missWorkFromDate) {
  //       const toDate = `${this.formatDate(
  //         new Date(ds.missWorkFromDate.toString())
  //       )}`;
  //       dateLine.push(toDate);
  //     }

  //     if (!!ds.missWorkFromDate && !!ds.missWorkFromDate) {
  //       const label = true //this.$store.state.vcponlineok.isApplicantVictim
  //         ? "HowManyDaysYou"
  //         : "HowManyDays";
  //       topCol.push({
  //         label: this.L(label),
  //         html: `<span class="ml-2">(${dateLine.join(" - ")})</span>`
  //       });
  //     }
  //     const addr = ds.address as EzAddress;
  //     const adr = this.formatAddressSingleLineHtml(addr);
  //     if (!!adr) {
  //       topCol.push({
  //         label: this.L("EmployerAddress"),
  //         html: adr
  //       });
  //     }

  //     const leftCol: IClaimSummaryLabelValue[] = [];
  //     if (!!ds.phoneNumber) {
  //       leftCol.push({
  //         label: this.L("EmployerPhoneNumber"),
  //         value: ds.phoneNumber
  //       });
  //     }

  //     if (!!ds.contactFirstName || !!ds.contactLastName) {
  //       leftCol.push({
  //         label: this.L("SupervisorName"),
  //         value: this.getFullNameOptions({
  //           first: ds.contactFirstName,
  //           last: ds.contactLastName
  //         })
  //       });
  //     }

  //     if (ds.victimSelfEmployed !== null) {
  //       const label = true //this.$store.state.vcponlineok.isApplicantVictim
  //         ? "IsYourIncomeResultSelfEmpl"
  //         : "IsVictimIncomeResultSelfEmpl";
  //       leftCol.push({
  //         label: this.L(label),
  //         value: `${this.boolToYesNo(ds.victimSelfEmployed)}`
  //       });
  //     }

  //     if (!!ds.selfEmploymentBusinessName) {
  //       const label = true //this.$store.state.vcponlineok.isApplicantVictim
  //         ? "IsYourIncomeResultSelfEmpl"
  //         : "IsVictimIncomeResultSelfEmpl";
  //       leftCol.push({
  //         label: this.L("SelfEmploymentBusinessName"),
  //         value: ds.selfEmploymentBusinessName
  //       });
  //     }

  //     const rightCol: IClaimSummaryLabelValue[] = [];
  //     if (!!ds.weeklyNetPay) {
  //       rightCol.push({
  //         label: this.L("WeeklyNetPay"),
  //         value: ds.weeklyNetPay
  //       });
  //     }

  //     if (!!ds.howLongEmployed) {
  //       const label = true //this.$store.state.vcponlineok.isApplicantVictim
  //         ? "HowLongHaveYouEmployed"
  //         : "HowLongHasVictimEmployed";
  //       rightCol.push({
  //         label: this.L(label),
  //         value: ds.howLongEmployed
  //       });
  //     }

  //     if (!!ds.howLongSelfEmployed) {
  //       const label = true //this.$store.state.vcponlineok.isApplicantVictim
  //         ? "HowLongYouSelfEmployed"
  //         : "HowLongVictimSelfEmployed";
  //       rightCol.push({
  //         label: this.L(label),
  //         value: ds.howLongSelfEmployed
  //       });
  //     }

  //     // if (!this.isObjectEmpty(ds.address)) {
  //     //   rightCol.push({
  //     //     label: this.L("EmployerAddress"),
  //     //     value: ds.address,
  //     //     component: () =>
  //     //       import("@/components/vcponlineok/address/address-view-component.vue")
  //     //   });
  //     // }

  //     const bottomCol: IClaimSummaryLabelValue[] = [];

  //     if (ds.isMissedWorkCovered !== null) {
  //       const label = true //this.$store.state.vcponlineok.isApplicantVictim
  //         ? "AnyDaysPaidFromOtherSource"
  //         : "AnyDaysPaidToVictimFromOtherSource";
  //       bottomCol.push({
  //         label: this.L(label),
  //         value: `${this.boolToYesNo(ds.isMissedWorkCovered)}`
  //       });
  //     }

  //     if (!!ds.missedWorkCoveredSource) {
  //       const label = true //this.$store.state.vcponlineok.isApplicantVictim
  //         ? "WhatSource"
  //         : "WhatSourceVictim";
  //       bottomCol.push({
  //         label: this.L(label),
  //         value: this.getConstName(
  //           "missedWorkCoveredSourceEnum",
  //           ds.missedWorkCoveredSource
  //         )
  //       });
  //     }

  //     const doc = ds.releasedToWorkDoctor;
  //     if (!!doc) {
  //       const label = true //this.$store.state.vcponlineok.isApplicantVictim
  //         ? "NameOfTheDoctorReleasedYou"
  //         : "NameOfTheDoctor";
  //       const docName = this.getFullNameOptions({
  //         prefix: doc.prefix,
  //         first: doc.firstName,
  //         middle: doc.middleName,
  //         last: doc.lastName,
  //         suffix: doc.suffix
  //       });
  //       if (!!docName || !!doc.phoneNumber) {
  //         let docContact = docName || "";
  //         docContact += doc.phoneNumber || "";

  //         bottomCol.push({
  //           label: this.L(label),
  //           value: docContact
  //         });
  //       }
  //       const addr = doc.address as EzAddress;
  //       const docAddr = this.formatAddressSingleLineHtml(addr);
  //       if (!!docAddr) {
  //         bottomCol.push({
  //           label: this.L("DoctorAddress"),
  //           html: docAddr
  //         });
  //       }
  //     }

  //     ret.itemList.push({
  //       headerHtml: header,
  //       oneColTop: topCol,
  //       leftCol: leftCol,
  //       rightCol: rightCol,
  //       oneColBottom: bottomCol,
  //       //attachments: ds.attachments
  //     });
  //     ret.attachments = ds.attachments;
  //   }

  //   return ret;
  // }

  // get civilSuitSectionData(): IClaimSummarySectionData | undefined {
  //   if (this.appObj == undefined || this.appObj.civilSuits == undefined) return;

  //   let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

  //   ret.topCenter.push({
  //     label: this.L("IsCivilSuitFiled"),
  //     value: `${this.boolToYesNo(this.appObj.isCivilSuitFiled)}`
  //   });

  //   if (!this.appObj.isCivilSuitFiled) {
  //   }

  //   for (const ds of this.appObj.civilSuits) {
  //     const header: string = `<span class="font-weight-bold">${this.getFullNameOptions(
  //       {
  //         first: ds.attorneyFirstName,
  //         last: ds.attorneyLastName
  //       }
  //     )}</span>`;

  //     const topCol: IClaimSummaryLabelValue[] = [];

  //     if (!!ds.lawFirmName) {
  //       topCol.push({
  //         label: this.L("LawFirm"),
  //         value: ds.lawFirmName
  //       });
  //     }

  //     const leftCol: IClaimSummaryLabelValue[] = [];

  //     if (!!ds.attorneyPhoneNumber) {
  //       leftCol.push({
  //         label: this.L("AttorneyPhoneNumber"),
  //         value: ds.attorneyPhoneNumber
  //       });
  //     }

  //     if (!!ds.civilCaseNumber) {
  //       leftCol.push({
  //         label: this.L("CivilSuitNumber"),
  //         value: ds.civilCaseNumber
  //       });
  //     }

  //     const rightCol: IClaimSummaryLabelValue[] = [];
  //     if (!!ds.civilSuitType) {
  //       rightCol.push({
  //         label: this.L("CivilSuitType"),
  //         value: ds.civilSuitType
  //       });
  //     }

  //     //const rightCol: IClaimSummaryLabelValue[] = [];
  //     const addr = ds.attorneyAddress as EzAddress;
  //     const adr = this.formatAddressSingleLineHtml(addr);
  //     if (!!adr) {
  //       topCol.push({
  //         label: this.L("Address"),
  //         html: adr
  //       });
  //     }

  //     ret.itemList.push({
  //       headerHtml: header,
  //       oneColTop: topCol,
  //       leftCol: leftCol,
  //       rightCol: rightCol,
  //       // attachments: ds.attachments
  //     });
  //     ret.attachments = ds.attachments;
  //   }

  //   return ret;
  // }

  // get insuranceSectionData(): IClaimSummarySectionData | undefined {
  //   if (this.appObj == undefined || this.appObj.insurances == undefined) return;

  //   let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

  //   ret.topCenter.push({
  //     label: this.L("HaveInsurance"),
  //     value: `${this.boolToYesNo(this.appObj.isInsuranceExists)}`
  //   });

  //   for (const ds of this.appObj.insurances) {
  //     const header: string = `<span class="font-weight-bold">${
  //       ds.insuranceCompanyName
  //     }</span> <small>(${this.getConstName(
  //       "insuranceType",
  //       ds.insuranceType
  //     )})</small>`;

  //     const leftCol: IClaimSummaryLabelValue[] = [];

  //     if (!!ds.policyGroupMemberNumber) {
  //       leftCol.push({
  //         label: this.L("PolicyNumber"),
  //         value: ds.policyGroupMemberNumber
  //       });
  //     }

  //     if (!!ds.policyTypeMedicaidSoonercareNumber) {
  //       leftCol.push({
  //         label: this.L("MedicaidOrSoonercareNumber"),
  //         value: ds.policyTypeMedicaidSoonercareNumber
  //       });
  //     }

  //     if (!!ds.policyIssuedDate) {
  //       leftCol.push({
  //         label: this.L("PolicyEffectiveDate"),
  //         value: this.formatDate(new Date(ds.policyIssuedDate.toString()))
  //       });
  //     }

  //     // Beneficiary info.

  //     const bf = ds.beneficiary;
  //     if (!!bf) {
  //       const bfName = this.getFullName(
  //         bf.prefix,
  //         bf.firstName,
  //         bf.middleName,
  //         bf.lastName,
  //         bf.suffix
  //       );
  //       if (bfName) {
  //         leftCol.push({
  //           label: this.L("BeneficiaryName"),
  //           value: bfName
  //         });
  //       }

  //       const rel = this.getRelationshipToVictimItem(
  //         bf.relationshipToVictim,
  //         bf.relationshipOther,
  //         "BeneficiaryRelationshipToTheVictim"
  //       );

  //       if (!!rel) {
  //         leftCol.push(rel);
  //       }
  //       const addr = bf.address as EzAddress;
  //       const adrLine = this.formatAddressSingleLineHtml(addr);
  //       if (!!adrLine) {
  //         leftCol.push({
  //           label: this.L("BeneficiarysAddress"),
  //           html: adrLine
  //         });
  //       }
  //     }

  //     const rightCol: IClaimSummaryLabelValue[] = [];

  //     if (!!ds.phone) {
  //       rightCol.push({
  //         label: this.L("PhoneNumber"),
  //         value: ds.phone
  //       });
  //     }

  //     if (!!ds.agentFirstName || !!ds.agentFirstName) {
  //       rightCol.push({
  //         label: this.L("AgentName"),
  //         value: this.getFullNameOptions({
  //           first: ds.agentFirstName,
  //           last: ds.agentLastName
  //         })
  //       });
  //     }

  //     if (!!ds.amountReceived) {
  //       rightCol.push({
  //         label: this.L("AmountReceived"),
  //         value: this.formatNumber(ds.amountReceived)
  //       });
  //     }

  //     //const bottomCol: IClaimSummaryLabelValue[] = [];

  //     ret.itemList.push({
  //       headerHtml: header,
  //       leftCol: leftCol,
  //       rightCol: rightCol,
  //       // oneColBottom: bottomCol,
  //       // attachments: ds.attachments
  //     });
  //     ret.attachments = ds.attachments;
  //   }

  //   return ret;
  // }

  // get expensesSectionData(): IClaimSummarySectionData | undefined {
  //   if (this.appObj == undefined || this.appObj.expencesInfo == undefined)
  //     return;

  //   let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

  //   const ds = this.appObj.expencesInfo;

  //   const oneColTop: IClaimSummaryLabelValue[] = [];

  //   let selectedValues: any[] = [];
  //   for (let i = 0; i < Object.keys(ds).length; i++) {
  //     const val: any = Object.values(ds)[i];
  //     const key: string = Object.keys(ds)[i];
  //     if (
  //       typeof val === "boolean" &&
  //       val === true &&
  //       key !== "otherCrimeRelatedExpences"
  //     ) {
  //       // if (key === "other") {
  //       //   selectedValues.push(ds.otherCrimeRelatedExpences);
  //       // } else {
  //         selectedValues.push(L(key));
  //       // }
  //     }
  //   }
  //   if (selectedValues.length > 0) {
  //     oneColTop.push({
  //       label: this.L("Expenses"),
  //       //html: `<ul><li>${selectedValues.join("</li><li>")}</li></ul>` //selectedValues.join("<br/>")
  //       valueList: selectedValues,
  //     });
  //   }

  //   if (!!ds.anticipatedExpenses) {
  //     oneColTop.push({
  //       label: this.L("AnticipatedExpenses"),
  //       html: this.newLineToHtml(ds.anticipatedExpenses)
  //     });
  //   }

  //   if (!!ds.victimInjuriesCausedByCrime) {
  //     oneColTop.push({
  //       label: this.L("ListInjuries"),
  //       html: this.newLineToHtml(ds.victimInjuriesCausedByCrime)
  //     });
  //   }
  //   if (!!ds.doctorsHospitalsMentalHealthProfessionalsList) {
  //     oneColTop.push({
  //       label: this.L("ListDoctors"),
  //       html: this.newLineToHtml(
  //         ds.doctorsHospitalsMentalHealthProfessionalsList
  //       )
  //     });
  //   }

  //   if (!!ds.funeralHome && !!ds.funeralHome.businessName) {
  //     oneColTop.push({
  //       label: this.L("FuneralHomeName"),
  //       value: ds.funeralHome.businessName
  //     });
  //   }
  //   if (ds.attachments !== undefined) {
  //     if (oneColTop.length > 0 || ds.attachments.length > 0) {
  //       ret.itemList.push({
  //         oneColTop: oneColTop,
  //         // leftCol: leftCol,
  //         // rightCol: rightCol,
  //         // attachments: ds.attachments
  //       });
  //       ret.attachments = ds.attachments;
  //     }
  //   }
  //   return ret;
  // }

  get crimeSectionData(): IClaimSummarySectionData | undefined {
    if (this.appObj == undefined || this.appObj.crimeInfo == undefined) return;

    let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

    const ds = this.appObj.crimeInfo;

    // // Top .
    // const oneColTop: IClaimSummaryLabelValue[] = [];

    // Left Column.
    const leftCol: IClaimSummaryLabelValue[] = [];

    let selectedValues: any[] = [];
    if (ds.crimeType !== undefined) {
      for (let i = 0; i < Object.keys(ds.crimeType).length; i++) {
        const val: string = Object.values(ds.crimeType)[i];
        const key: string = Object.keys(ds.crimeType)[i];
        if (!!val && key !== "otherDesc" && key !== "idGuid") {
          if (key === "other") {
            selectedValues.push(`${ds.crimeType.otherDesc}`);
          } else {
            selectedValues.push(this.L(key));
          }
        }
      }
    }

    leftCol.push({
      label: this.L("CrimeTypes"),
      // html: selectedValues.join("<br/>")
      valueList: selectedValues
    });

    //if (!this.isObjectEmpty(ds.address)) {
    //const addr = ds.address as EzAddress;
    //let crimeLoc: string | null = null;
    // if (
    //   ds.crimeLocationType !== undefined &&
    //   ds.crimeLocationType == util.abp.constant.locationType.other
    // ) {
    //   crimeLoc = ds.crimeLocationTypeOther as string;
    // } else {
    //   crimeLoc = this.getConstName(
    //     "locationType",
    //     ds.crimeLocationType
    //   ) as string;
    // }
    //let crimeCity = addr.city;
    // commented out due no county now Oct'19
    // if (!!addr.county) {
    //   crimeCnt += `, ${this.getConstName("OKCounty", addr.county)} ${L(
    //     "County"
    //   )}`;
    // }

    // leftCol.push({
    //   label: this.L("PrimaryLocationOfCrime"),
    //   //html: `<div>${crimeLoc}</div>`
    //   value: crimeLoc
    // });
    // leftCol.push({
    //   label: this.L("CityOfCrime"),
    //   //html: `<div>${crimeCity}</div>`
    //   value: crimeCity
    // });

    if (ds.dateOfCrime !== undefined) {
      abp.log.debug({'claim-summary-sections.vue: ds.dateOfCrime':ds.dateOfCrime});
      //var dtCrime = new Date(ds.dateOfCrime.toString());
      // if (!!ds.timeOfCrime) {
      //   dtCrime = new Date(dtCrime.toDateString() + " " + ds.timeOfCrime);
      // }
      leftCol.push({
        label: this.L("DateOfCrime"),
        value: this.formatDate(ds.dateOfCrime) //(dtCrime)
      });
    }

    // Right col.
    const rightCol: IClaimSummaryLabelValue[] = [];

    if (ds.crimeCounty !== undefined && ds.crimeCounty !== null) {
      abp.log.debug({'claim-summary-sections.vue: ds.crimeCounty':ds.crimeCounty});
      rightCol.push({
        label: this.L("County"),
        value: this.getConstName("oKCounty", ds.crimeCounty)
      });
    }

    // if (
    //   ds.reportedByMinorToAdultDate !== undefined &&
    //   ds.reportedByMinorToAdultDate !== null
    // ) {
    //   var dtCrime = new Date(ds.reportedByMinorToAdultDate.toString());
    //   if (!!ds.reportedByMinorToAdultTime) {
    //     dtCrime = new Date(
    //       dtCrime.toDateString() + " " + ds.reportedByMinorToAdultTime
    //     );
    //   }
    //   rightCol.push({
    //     label: this.L("IfVictimIsAChild"),
    //     value: this.formatDateTime(dtCrime)
    //   });
    // }

    // if (ds.reportedToLeaDate !== undefined) {
    //   var dtCrime = new Date(ds.reportedToLeaDate.toString());
    //   if (!!ds.reportedToLeaTime) {
    //     dtCrime = new Date(dtCrime.toDateString() + " " + ds.reportedToLeaTime);
    //   }
    //   rightCol.push({
    //     label: this.L("ReportedDate"),
    //     value: this.formatDateTime(dtCrime)
    //   });
    // }

    // if (!!ds.reportedToAgencyName) {
    //   rightCol.push({
    //     label: this.L("AgencyName"),
    //     value: ds.reportedToAgencyName
    //   });
    // }

    // if (!!ds.reportNumber) {
    //   rightCol.push({
    //     label: this.L("CrimeCaseNumber"),
    //     value: ds.reportNumber
    //   });
    // }

    // if (!!ds.reportedBy) {
    //   rightCol.push({
    //     label: this.L("WhoReportedTheCrime"),
    //     value: ds.reportedBy
    //   });
    // }

    // bottom col.
    const bottomCol: IClaimSummaryLabelValue[] = [];

    // bottomCol.push({
    //   label: this.L("CrimeDescription"),
    //   value: ds.crimeDescription
    // });

    // if (!!ds.agencyContactInformation) {
    //   bottomCol.push({
    //     label: this.L("AgencyContactInfo"),
    //     value: ds.agencyContactInformation
    //   });
    // }

    ret.itemList.push({
      leftCol: leftCol,
      rightCol: rightCol,
      oneColBottom: bottomCol
    });

    return ret;
  }

  // get contactSectionData(): IClaimSummarySectionData | undefined {
  //   if (this.appObj == undefined || this.appObj.contactPersons == undefined)
  //     return;

  //   let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

  //   // ret.topCenter = {
  //   //   label: this.L("HasRepresentativeQuestion"),
  //   //   value: `${this.boolToYesNo(this.appObj.isThereAnyContactPersons)}`
  //   // };

  //   for (let ds of this.appObj.contactPersons) {
  //     const header = `<strong>

  //         ${this.getFullName(
  //           ds.prefix,
  //           ds.firstName,
  //           ds.middleName,
  //           ds.lastName,
  //           ds.suffix
  //         )}
  //     </strong>
  //     `;

  //     // Left Column.
  //     const leftCol: IClaimSummaryLabelValue[] = [];

  //     let relToClt = undefined; //ds.relationshipOther;
  //     if (this.hasValue(ds.relationshipToVictim)) {
  //       if (
  //         ds.relationshipToVictim ===
  //         util.abp.constant.relationshipToVictim.otherDescription
  //       ) {
  //         relToClt = ds.relationshipOther;
  //       } else {
  //         relToClt = this.getConstName(
  //           "relationshipToVictim",
  //           ds.relationshipToVictim
  //         );
  //       }
  //       if (relToClt !== "") {
  //         leftCol.push({
  //           label: this.L("RelationshipToVictim"),
  //           value: relToClt
  //         });
  //       }
  //     }
  //     leftCol.push({
  //       label: this.L("TribalVictimAdvocate"),
  //       value: this.boolToYesNo(ds.isTribalVictimStaff)
  //     });

  //     // Right col.
  //     const rightCol: IClaimSummaryLabelValue[] = [];

  //     rightCol.push({
  //       label: this.L("PrimaryPhoneNumber"),
  //       value: ds.phoneNumber
  //     });

  //     if (!!ds.phoneNumberOther) {
  //       rightCol.push({
  //         label: this.L("OtherPhone"),
  //         value: ds.phoneNumberOther
  //       });
  //     }

  //     // Bottom col.
  //     const bottomCol: IClaimSummaryLabelValue[] = [];

  //     // if (!this.isObjectEmpty(ds.address)) {
  //     //   bottomCol.push({
  //     //     label: this.L("ResidentialAddress"),
  //     //     value: ds.address,
  //     //     component: () =>
  //     //       import("@/components/vcponlineok/address/address-view-component.vue")
  //     //   });
  //     // }
  //     const addr = ds.address as EzAddress;
  //     const adr = this.formatAddressSingleLineHtml(addr);
  //     if (!!adr) {
  //       bottomCol.push({
  //         label: this.L("ResidentialAddress"),
  //         html: adr
  //       });
  //     }
  //     if (ds.allowOCVCToContactLocate) {
  //       bottomCol.push({
  //         value: this.L("IgivePermissionToCallOrWrite")
  //         // value: this.boolToYesNo(ds.allowOCVCToContactLocate)
  //       });
  //     }

  //     if (ds.allowOCVCTodiscussClaim) {
  //       bottomCol.push({
  //         value: this.L("IgivePermissionToDiscuss")
  //         // value: this.boolToYesNo(ds.allowOCVCTodiscussClaim)
  //       });
  //     }

  //     ret.itemList.push({
  //       headerHtml: header,
  //       leftCol: leftCol,
  //       rightCol: rightCol,
  //       oneColBottom: bottomCol
  //     });
  //   }

  //   return ret;
  // }

  get claimantSectionData(): IClaimSummarySectionData | undefined {
    abp.log.debug({ "claim-summary-sections.vue: this.appObj": this.appObj });
    if (
      this.appObj == undefined ||
      this.appObj.claimants == undefined ||
      this.appObj.claimants.length == 0
    )
      return;

    let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

    for (let ds of this.appObj.claimants) {
      // Left Column.
      const leftCol: IClaimSummaryLabelValue[] = [];

      let fullName = this.getFullName(
        ds.prefix,
        ds.firstName,
        ds.middleName,
        ds.lastName,
        ds.suffix
      );
      if (!!fullName) {
        leftCol.push({
          label: this.L("FullName"),
          value: fullName
        });
      }

      const rel = this.getClaimantsRelationshipToVictimItem(
        ds.relationshipToVictim,
        ds.relationshipOther
      );
      if (!!rel) {
        leftCol.push(rel);
      }

      if (!!ds.dob) {
        leftCol.push({
          label: this.L("DateOfBirth"),
          value: this.formatDate(new Date(ds.dob.toString()))
        });
      }
      // if (!!ds.ssn) {
      //   leftCol.push({
      //     label: this.L("SSNShort"),
      //     value: ds.ssn
      //   });
      // }

      if (ds.gender !== undefined && ds.gender !== null) {
        leftCol.push({
          label: this.L("Gender"),
          value: this.getConstName("gender", ds.gender)
        });
      }

      // Right col.
      const rightCol: IClaimSummaryLabelValue[] = [];

      // rightCol.push({
      //   label: this.L("PrimaryPhoneNumber"),
      //   value: ds.phoneNumber
      // });

      // if (!!ds.phoneNumberOther) {
      //   rightCol.push({
      //     label: this.L("OtherPhone"),
      //     value: ds.phoneNumberOther
      //   });
      // }

      // if (!this.isObjectEmpty(ds.address)) {
      //   rightCol.push({
      //     label: this.L("ResidentialAddress"),
      //     value: ds.address,
      //     component: () =>
      //       import("@/components/vcponlineok/address/address-view-component.vue")
      //   });
      // }

      // if (!this.isObjectEmpty(ds.mailingAddress)) {
      //   rightCol.push({
      //     label: this.L("MailingAddress"),
      //     value: ds.mailingAddress,
      //     component: () =>
      //       import("@/components/vcponlineok/address/address-view-component.vue")
      //   });
      // }

      // Bottom col
      const bottomCol: IClaimSummaryLabelValue[] = [];

      // if (!!ds.email) {
      //   bottomCol.push({
      //     label: this.L("EmailAddress"),
      //     value: ds.email
      //   });
      // }

      const addr = ds.address as EzAddress;
      const adr = this.formatAddressSingleLineHtml(addr);
      if (!!adr) {
        bottomCol.push({
          label: this.L("ResidentialAddress"),
          html: adr
        });
      }

      // const mAddr = ds.mailingAddress as EzAddress;
      // const adrMail = this.formatAddressSingleLineHtml(mAddr);
      // if (!!adrMail) {
      //   bottomCol.push({
      //     label: this.L("MailingAddress"),
      //     html: adrMail
      //   });
      // }

      // if (!!ds.email) {
      //   bottomCol.push({
      //     label: this.L("Email"),
      //     value: ds.email
      //   });
      // }

      ret.itemList.push({
        leftCol: leftCol,
        rightCol: rightCol,
        oneColBottom: bottomCol
      });
    }

    return ret;
  }

  // get raceSectionData(): ClaimSummarySectionItem[] {
  //   let ret: ClaimSummarySectionItem[] = [];
  //   if (this.viewModel == undefined) return ret;
  get raceSectionData(): IClaimSummarySectionData | undefined {
    if (
      this.appObj == undefined ||
      this.viewModel.fedReportingInfo == undefined
    )
      return;

    let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

    const ds: AppFedReportingInfoDto = this.viewModel.fedReportingInfo;

    const topCol: IClaimSummaryLabelValue[] = [];

    let selectedValues: any[] = [];
    for (let i = 0; i < Object.keys(ds).length; i++) {
      const val: string = Object.values(ds)[i];
      const key: string = Object.keys(ds)[i];
      if (
        !!val &&
        key !== "otherRace" &&
        key !== "multipleRaces" &&
        key !== "tribalAffiliation"
      ) {
        if (key === "other") {
          selectedValues.push(`${ds.other}`);
          // } else if (key === "tribalAffiliation") {
          //   selectedValues.push(`${L(key)} (${ds.tribalAffiliation})`);
        } else {
          selectedValues.push(L(key));
        }
      }
    }
    if (selectedValues.length > 0) {
      topCol.push({
        label: this.L("Ethnicity"),
        //html: `<ul><li>${selectedValues.join("</li><li>")}</li></ul>` //selectedValues.join("<br/>")
        valueList: selectedValues
      });
    }

    if (!!ds.tribalAffiliation) {
      topCol.push({
        label: this.L("tribalAffiliation"),
        //html: `<ul><li>${ds.tribalAffiliation}</li></ul>`
        value: ds.tribalAffiliation
      });
    }

    if (topCol.length > 0) {
      ret.itemList.push({ oneColTop: topCol });
    }
    return ret;
  }

  // get victimSectionData(): ClaimSummarySectionItem[] {
  //   let ret: ClaimSummarySectionItem[] = [];
  //   // abp.log.debug({ "appSummary start...": ret });
  //   if (this.appObj == undefined || !this.appObj.crimeVictimInfo) return ret;
  get victimSectionData(): IClaimSummarySectionData | undefined {
    if (this.appObj == undefined || this.appObj.crimeVictimInfo == undefined)
      return;

    let ret: IClaimSummarySectionData = { itemList: [], topCenter: [] };

    let ds = this.appObj.crimeVictimInfo;
    // Left Column.
    const leftCol: IClaimSummaryLabelValue[] = [];
    leftCol.push({
      label: this.L("FullName"),
      value: this.getFullName(
        ds.prefix,
        ds.firstName,
        ds.middleName,
        ds.lastName,
        ds.suffix
      )
    });
    // leftCol.push({
    //   label: this.L("SSNShort"),
    //   value: ds.ssn
    // });

    if (!!ds.dob) {
      leftCol.push({
        label: this.L("DateOfBirth"),
        value: this.formatDate(new Date(ds.dob.toString()))
      });
    }

    // if (!!ds.phoneNumber) {
    //   leftCol.push({
    //     label: this.L("PrimaryPhoneNumber"),
    //     value: ds.phoneNumber
    //   });
    // }

    // if (!!ds.phoneNumberOther) {
    //   leftCol.push({
    //     label: this.L("OtherPhone"),
    //     value: ds.phoneNumberOther
    //   });
    // }

    // Right column
    const rightCol: IClaimSummaryLabelValue[] = [];

    let ageAtCrimeTime: string | undefined = "";
    ageAtCrimeTime = this.appObj.crimeVictimInfo.ageAtCrimeTime;

    if (!!ageAtCrimeTime) {
      rightCol.push({
        label: this.L("AgeAtCrimeTime"),
        value: ageAtCrimeTime
      });
    }

    rightCol.push({
      label: this.L("Gender"),
      value: this.getConstName("gender", ds.gender)
    });

    // const rel = this.getRelationshipToVictimItem(
    //   ds.publicUsersRelationshipToVictim,
    //   ds.publicUsersRelationshipToVictimOtherDesc,
    //   "ApplicantRelToVictim"
    // );
    // if (!!rel) {
    //   rightCol.push(rel);
    // }

    // rightCol.push({
    //   label: this.L("IsVictimDeceased"),
    //   value: this.boolToYesNo(ds.isDeceased)
    // });

    // if (ds.isDeceased && !!ds.dod) {
    //   rightCol.push({
    //     label: this.L("DOD"),
    //     value: this.formatDate(new Date(ds.dod.toString()))
    //   });
    // }

    // if (!this.isObjectEmpty(ds.address)) {
    //   rightCol.push({
    //     label: this.L("ResidentialAddress"),
    //     value: ds.address,
    //     component: () =>
    //       import("@/components/vcponlineok/address/address-view-component.vue")
    //   });
    // }

    // if (!this.isObjectEmpty(ds.mailingAddress)) {
    //   rightCol.push({
    //     label: this.L("MailingAddress"),
    //     value: ds.mailingAddress,
    //     component: () =>
    //       import("@/components/vcponlineok/address/address-view-component.vue")
    //   });
    // }

    // One Column Bottom
    const oneColBottom: IClaimSummaryLabelValue[] = [];

    // if (!!ds.email) {
    //   oneColBottom.push({
    //     label: this.L("Email"),
    //     value: ds.email
    //   });
    // }

    // const addr = ds.address as IEzAddress;
    // const adr = this.formatAddressSingleLineHtml(addr);
    // if (!!adr) {
    //   oneColBottom.push({
    //     label: this.L("ResidentialAddress"),
    //     html: adr
    //   });
    // }

    // const mAddr = ds.mailingAddress as EzAddress;
    // const adrMail = this.formatAddressSingleLineHtml(mAddr);
    // if (!!adrMail) {
    //   oneColBottom.push({
    //     label: this.L("MailingAddress"),
    //     html: adrMail
    //   });
    // }

    // if (!!ds.priorDisabilities) {
    //   oneColBottom.push({
    //     label: this.L("DisabilitiesPriorToIncident"),
    //     html: this.newLineToHtml(ds.priorDisabilities)
    //   });
    // }

    // append race to this section.
    if (this.raceSectionData != undefined) {
      const enthicitySection = <IClaimSummarySectionData>this.raceSectionData;
      enthicitySection.itemList.forEach(i => {
        i.headerHtml = i.headerHtml;
        if (i.oneColTop) leftCol.push(...i.oneColTop);
        if (i.leftCol) leftCol.push(...i.leftCol);
        if (i.rightCol) rightCol.push(...i.rightCol);
        if (i.oneColBottom) rightCol.push(...i.oneColBottom);
      });
    }

    ret.itemList.push({
      leftCol: leftCol,
      rightCol: rightCol,
      oneColBottom: oneColBottom
    });

    // abp.log.debug({"victim before":ret.itemList});
    // abp.log.debug({"victim after":ret.itemList});

    return ret;
  }
}
